import Vue from 'vue'
import appConfig from '@/config.js'

const erpHooksModel = vm => ({
  title: vm.$gettext('ERP Hooks'),
  endpoint: 'erp-hooks',
  noIdLink: true,
  fields: [
    {
      key: 'id'
    },
    {
      key: 'target',
      label: vm.$gettext('Target'),
      sortable: true
    },
    {
      key: 'operation',
      label: vm.$gettext('Operation')
    },
    {
      key: 'entity',
      label: vm.$gettext('Entity'),
      formatter: (value, key, item) => {
        const entity = item.model_type.split('\\')[item.model_type.split('\\').length - 1]
        let link = ''
        switch (entity) {
          case 'Company':
            link += '<a href="/edit/companies/' + item.model_id + '" target="_blank">'
            break
          case 'AccountTransaction':
            link +=
              '<a href=\'/transactions/?s=%5B%5B"id","eq","' + item.model_id + '"%5D%5D\' target="_blank">'
            break
          default:
            link += '<a href="/edit/users/' + item.model_id + '" target="_blank">'
            break
        }
        link += entity + ' #' + item.model_id + '</a>'
        return link
      }
    },
    {
      key: 'status',
      label: vm.$gettext('Status')
    },
    {
      key: 'attempts',
      label: vm.$gettext('Attempts'),
      sortable: true
    },
    {
      key: 'sync_error',
      label: vm.$gettext('Sync Error')
    },
    {
      key: 'scheduled_date',
      label: vm.$gettext('Scheduled Date')
    },
    {
      key: 'created_at',
      label: vm.$gettext('Created At')
    }
  ],
  extraActions: [
    {
      label: vm.$gettext('Reschedule'),
      type: 'button',
      icon: 'redo',
      title: vm.$gettext('Reschedule this ERP Hook'),
      variant: 'dark',
      position: 'end',
      disabledCondition: item => {
        return item.status !== 'canceled'
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to RESCHEDULE this ERP Hook?'))) {
          Vue.http.put(appConfig.api.baseUrl + 'erp-hooks/' + item.id + '/reschedule').then(response => {
            window.moovaAdmin.refreshTable('apiListTable')
          })
        }
      }
    },
    {
      label: vm.$gettext('Discard'),
      type: 'button',
      icon: 'trash-alt',
      title: vm.$gettext('Discard this ERP Hook'),
      variant: 'danger',
      position: 'end',
      disabledCondition: item => {
        return item.status !== 'pending'
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to DISCARD this ERP Hook?'))) {
          Vue.http.delete(appConfig.api.baseUrl + 'erp-hooks/' + item.id).then(response => {
            window.moovaAdmin.refreshTable('apiListTable')
          })
        }
      }
    }
  ],
  filters: ['id', 'target', 'operation', 'status', 'model_type', 'model_id', 'attempts']
})

export default erpHooksModel
